import { render, staticRenderFns } from "./EdenCustomCalendar.vue?vue&type=template&id=4d2dfa24"
import script from "./EdenCustomCalendar.vue?vue&type=script&lang=js"
export * from "./EdenCustomCalendar.vue?vue&type=script&lang=js"
import style0 from "./EdenCustomCalendar.vue?vue&type=style&index=0&id=4d2dfa24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports